/* ============================================================
   CAPSULE DISTRICT — homepage interactions
   Ported from the design prototype's React app to vanilla JS,
   wired to Shopify's Ajax Cart API for real cart behaviour.
   ============================================================ */
(function () {
  'use strict';

  if (window.__cdInit) return;
  window.__cdInit = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isHome = document.body.classList.contains('cd-home');
  var isColl = document.body.classList.contains('cd-collection');
  var isAbout = document.body.classList.contains('cd-nosotros');
  var isConsig = document.body.classList.contains('cd-consignacion');
  var isPolicy = document.body.classList.contains('cd-policy');
  var isProduct = document.body.classList.contains('cd-product');
  // 404, índice de colecciones, páginas sueltas, blog y artículos
  var isDoc = document.body.classList.contains('cd-doc');
  if (!isHome && !isColl && !isAbout && !isConsig && !isPolicy && !isProduct && !isDoc) return;
  var root = document;

  var nav = root.querySelector('[data-cd-nav]');
  var hero = root.querySelector('[data-cd-hero]');
  var cover = root.querySelector('#cd-cover');
  var detailPanel = root.querySelector('[data-cd-detail]');
  var bagPanel = root.querySelector('[data-cd-bag]');
  var bagCountEls = root.querySelectorAll('[data-cd-bag-count]');
  var searchOverlay = root.querySelector('[data-cd-search]');
  var searchForm = root.querySelector('[data-cd-search-form]');
  var searchInput = root.querySelector('[data-cd-search-input]');
  var searchResults = root.querySelector('[data-cd-search-results]');
  var searchList = root.querySelector('[data-cd-search-list]');

  var state = {
    detailOpen: false,
    bagOpen: false,
    searchOpen: false,
    navOpen: false,
    product: null,
    size: null,
    qty: 1,
  };

  /* ---------------- overlay <-> browser history ----------------
     The product detail, bag, search and mobile nav are panels layered over the
     current page, not real navigations. Without this, the browser's Back button
     leaves the store altogether while a panel is open. We keep exactly one
     history entry alive for "some panel is open" so Back closes the panel and
     drops the visitor back on the page (and scroll position) they came from.
     While the product detail is up, that entry carries the product's own URL,
     so the address bar is something people can copy and share; the bag, search
     and nav keep the page's URL. */
  var overlayPushed = false; // we own a history entry for the open panel
  var overlayBase = null; // the page's URL, under our entry
  var pendingBack = false; // a history.back() of ours is in flight
  var syncQueued = false;
  var navigatingAway = false; // a real page load is under way, leave history be

  // a fresh load can inherit our marker (reload with a panel open); clear it so
  // the first close doesn't try to pop an entry that no panel is using
  if (history.state && history.state.cdOverlay) {
    try { history.replaceState(null, '', location.href); } catch (e) {}
  }

  function anyOverlayOpen() {
    return !!(state.detailOpen || state.bagOpen || state.searchOpen || state.navOpen);
  }

  function syncOverlayHistory() {
    syncQueued = false;
    if (navigatingAway) return; // never fight an in-flight navigation
    if (pendingBack) return; // re-synced once our own popstate lands
    var open = anyOverlayOpen();
    if (open && overlayPushed) {
      // already on our entry: a product swap (related row) or detail -> bag
      try { history.replaceState(history.state, '', overlayUrl()); } catch (e) {}
      return;
    }
    if (open === overlayPushed) return;
    if (open) {
      overlayPushed = true;
      overlayBase = location.href;
      try {
        history.pushState({ cdOverlay: true, base: overlayBase }, '', overlayUrl());
      } catch (e) {
        overlayPushed = false;
      }
    } else {
      overlayPushed = false;
      pendingBack = true;
      history.back();
    }
  }

  function overlayUrl() {
    if (state.detailOpen && state.product && state.product.url) return state.product.url;
    return overlayBase || location.href;
  }

  // deferred so a panel swap (detail -> bag on "add to cart") settles as a
  // single net state instead of popping and re-pushing an entry
  function scheduleOverlayHistory() {
    if (syncQueued) return;
    syncQueued = true;
    setTimeout(syncOverlayHistory, 0);
  }

  function closeAllOverlays() {
    if (state.detailOpen) closeDetail();
    if (state.bagOpen) closeBag();
    if (state.searchOpen) closeSearch();
    if (state.navOpen && typeof closeMobileNav === 'function') closeMobileNav();
  }

  window.addEventListener('pagehide', function () { navigatingAway = true; });
  // coming back via bfcache: the panels are shut again, so start clean
  window.addEventListener('pageshow', function (e) {
    navigatingAway = false;
    if (e.persisted) {
      overlayPushed = !!(history.state && history.state.cdOverlay);
      pendingBack = false;
    }
  });

  window.addEventListener('popstate', function () {
    if (pendingBack) {
      pendingBack = false;
      scheduleOverlayHistory();
      return;
    }
    overlayPushed = false;
    closeAllOverlays();
    // Forward onto a product entry of ours: the panel is shut, so the bar would
    // show the product over the page underneath. Put the page's URL back.
    if (history.state && history.state.cdOverlay && history.state.base) {
      try { history.replaceState(null, '', history.state.base); } catch (e) {}
    }
    scheduleOverlayHistory();
  });

  /* ---------------- page-load cover ----------------
     Four beats, each one a class the CSS reacts to:
       converged -> the C and D fly in from opposite sides and meet
       struck    -> the mark's centre slash flashes and the glyph recoils
       named     -> the CAPSULE DISTRICT wordmark fades in beneath
       out       -> the whole cover fades away
     Reduced motion collapses the travel and recoil (see the media query in the
     CSS) but keeps the same beats, so the cover still clears on schedule. */
  if (cover && isHome) {
    var coverBeats = reduceMotion
      ? { converge: 0, strike: 120, name: 240, out: 700, hide: 1300 }
      : { converge: 0, strike: 560, name: 820, out: 1900, hide: 2500 };
    // Force the start state to flush before flipping the class, so the halves
    // have a from-value to travel from. A rAF would do it too, but Chrome
    // throttles rAF in a tab that isn't rendering while the setTimeouts below
    // keep running — that combination skips the fly-in and lands the mark
    // half-built. Reading offsetWidth is synchronous and always happens.
    void cover.offsetWidth;
    cover.classList.add('is-converged');
    setTimeout(function () { cover.classList.add('is-struck'); }, coverBeats.strike);
    setTimeout(function () { cover.classList.add('is-named'); }, coverBeats.name);
    setTimeout(function () { cover.classList.add('out'); }, coverBeats.out);
    setTimeout(function () { cover.classList.add('hidden'); }, coverBeats.hide);
  }

  /* ---------------- custom cursor ---------------- */
  (function () {
    if (window.matchMedia('(hover: none), (pointer: coarse)').matches) return;
    var c = document.createElement('div');
    c.className = 'cd-cursor';
    c.innerHTML = '<span class="x-line h"></span><span class="x-line v"></span><span class="view-label">Ver más</span>';
    document.body.appendChild(c);
    var tx = 0, ty = 0, cx = 0, cy = 0;
    function loop() {
      cx += (tx - cx) * 0.28;
      cy += (ty - cy) * 0.28;
      c.style.left = cx + 'px';
      c.style.top = cy + 'px';
      requestAnimationFrame(loop);
    }
    window.addEventListener('mousemove', function (e) { tx = e.clientX; ty = e.clientY; });
    window.addEventListener('mouseover', function (e) {
      var cta = e.target.closest('[data-cursor="cta"]');
      var view = e.target.closest('.cd-cell__media, .cd-cat__media');
      var link = e.target.closest('[data-cursor="link"]');
      c.classList.toggle('is-cta', !!cta);
      c.classList.toggle('is-view', !!view && !cta);
      c.classList.toggle('is-ring', !!link && !cta && !view);
    });
    document.addEventListener('mouseleave', function () { c.style.opacity = 0; });
    document.addEventListener('mouseenter', function () { c.style.opacity = 1; });
    loop();
  })();

  /* ---------------- nav: scroll-aware + bag count pop ---------------- */
  if (nav) {
    var onScroll = function () {
      nav.classList.toggle('is-scrolled', window.scrollY > window.innerHeight * 0.6);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    var shopLink = nav.querySelector('[data-cd-nav-shop]');
    var bagLink = nav.querySelector('[data-cd-nav-bag]');
    if (shopLink) shopLink.addEventListener('click', function (e) {
      e.preventDefault();
      closeBag(); closeDetail();
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    });
    if (bagLink) bagLink.addEventListener('click', function (e) { e.preventDefault(); openBag(); });
  }

  /* ---------------- mobile nav (burger + off-canvas panel) ---------------- */
  var navBurger = root.querySelector('[data-cd-nav-burger]');
  var navMobile = root.querySelector('[data-cd-nav-mobile]');
  if (navBurger && navMobile) {
    var navMobileClose = navMobile.querySelector('[data-cd-nav-mobile-close]');
    var openMobileNav = function () {
      navMobile.classList.add('is-open');
      navMobile.setAttribute('aria-hidden', 'false');
      navBurger.setAttribute('aria-expanded', 'true');
      state.navOpen = true;
      scheduleOverlayHistory();
      lockScroll();
    };
    var navMobilePanel = navMobile.querySelector('.cd-nav-mobile__panel');
    // second-level menus: nav entries that own a dropdown (Vestuario, Sneakers,
    // Marcas) slide their sub-categories in over the panel body instead of
    // navigating, so the whole menu tree is reachable on a phone
    var closeSubmenus = function () {
      navMobile.querySelectorAll('[data-cd-dropdown].is-open').forEach(function (w) {
        w.classList.remove('is-open');
      });
      if (navMobilePanel) navMobilePanel.classList.remove('has-submenu');
    };
    var closeMobileNav = function () {
      navMobile.classList.remove('is-open');
      navMobile.setAttribute('aria-hidden', 'true');
      navBurger.setAttribute('aria-expanded', 'false');
      state.navOpen = false;
      scheduleOverlayHistory();
      unlockScroll();
      closeSubmenus();
    };
    navBurger.addEventListener('click', openMobileNav);
    if (navMobileClose) navMobileClose.addEventListener('click', closeMobileNav);
    navMobile.addEventListener('click', function (e) { if (e.target === navMobile) closeMobileNav(); });

    var navMobileParents = navMobile.querySelectorAll('[data-cd-dropdown] > .cd-navlink');
    navMobileParents.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        closeSubmenus();
        a.parentNode.classList.add('is-open');
        if (navMobilePanel) navMobilePanel.classList.add('has-submenu');
      });
    });
    navMobile.querySelectorAll('[data-cd-submenu-back]').forEach(function (b) {
      b.addEventListener('click', closeSubmenus);
    });

    // every link closes the whole menu on the way out — except the drill-down
    // parents above, which open a submenu rather than going anywhere
    navMobile.querySelectorAll('a').forEach(function (a) {
      if (Array.prototype.indexOf.call(navMobileParents, a) !== -1) return;
      a.addEventListener('click', function () {
        // a real navigation follows, so close the panel visually only — popping
        // our history entry here would race the page load
        navigatingAway = true;
        closeMobileNav();
      });
    });
  }

  /* ---------------- theme toggle (light / dark) ---------------- */
  (function () {
    var SUN = '<svg class="cd-icon-sun" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="4.4"/><path d="M12 2.8v2M12 19.2v2M2.8 12h2M19.2 12h2M5.1 5.1l1.4 1.4M17.5 17.5l1.4 1.4M18.9 5.1l-1.4 1.4M6.5 17.5l-1.4 1.4"/></svg>';
    var MOON = '<svg class="cd-icon-moon" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" aria-hidden="true"><path d="M20.6 13.8A8.5 8.5 0 0 1 10.2 3.4a8.5 8.5 0 1 0 10.4 10.4Z"/></svg>';
    // the desktop nav has no toggle in its markup, so build one for each nav
    root.querySelectorAll('.cd-nav__right').forEach(function (right) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cd-nav__icon-btn cd-theme-toggle';
      btn.setAttribute('data-cursor', 'link');
      btn.setAttribute('aria-label', 'Cambiar tema');
      btn.innerHTML = SUN + MOON;
      right.insertBefore(btn, right.firstChild);
    });
    // bind every toggle on the page exactly once — the ones just injected plus
    // the server-rendered one the mobile panel carries (snippets/cd-theme-toggle)
    root.querySelectorAll('.cd-theme-toggle').forEach(function (btn) {
      if (btn.dataset.cdThemeBound) return;
      btn.dataset.cdThemeBound = '1';
      btn.addEventListener('click', function () {
        var light = !document.documentElement.classList.contains('cd-light');
        document.documentElement.classList.toggle('cd-light', light);
        try { localStorage.setItem('cd-theme', light ? 'light' : 'dark'); } catch (e) {}
      });
    });
  })();

  /* ---------------- collection hero: clip-reveal + fades ----------------
     policy pages and the document pages (404, /collections, páginas, blog)
     reuse the same hero markup, so they share the reveal */
  if (isColl || isPolicy || isDoc) {
    var collTitle = root.querySelector('[data-cd-coll-title]');
    var collFades = root.querySelectorAll('.cd-coll-hero__rule, .cd-coll-hero__meta, .cd-coll-hero__searchform');
    if (reduceMotion) {
      if (collTitle) collTitle.classList.add('in');
      collFades.forEach(function (f) { f.classList.add('in'); });
    } else {
      setTimeout(function () { if (collTitle) collTitle.classList.add('in'); }, 300);
      collFades.forEach(function (f, i) {
        setTimeout(function () { f.classList.add('in'); }, 600 + i * 120);
      });
    }
  }

  /* ---------------- about hero: title clip-reveal + content fades ---------------- */
  if (isAbout || isConsig) {
    var aboutTitle = root.querySelector('[data-cd-about-title]');
    var aboutFades = root.querySelectorAll('.cd-about-hero__kicker, .cd-consig-hero__lead, .cd-consig-hero__actions');
    if (reduceMotion) {
      if (aboutTitle) aboutTitle.classList.add('in');
      aboutFades.forEach(function (f) { f.classList.add('in'); });
    } else {
      setTimeout(function () { if (aboutTitle) aboutTitle.classList.add('in'); }, 300);
      aboutFades.forEach(function (f, i) {
        setTimeout(function () { f.classList.add('in'); }, 600 + i * 120);
      });
    }

    var aboutReveals = root.querySelectorAll('.cd-about__inner, .cd-map__inner, .cd-video__embed, [data-cd-consig-reveal]');
    if (reduceMotion) {
      aboutReveals.forEach(function (el) { el.classList.add('in'); });
    } else {
      var aboutIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            aboutIo.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2 });
      aboutReveals.forEach(function (el) { aboutIo.observe(el); });
    }
  }

  /* ---------------- hero: letter stagger + parallax ---------------- */
  if (isHome && hero) {
    var letters = hero.querySelectorAll('.cd-hero__ltr');
    var fades = hero.querySelectorAll('.cd-hero__cta, .cd-hero__rule, .cd-hero__meta, .cd-hero__reg');
    if (reduceMotion) {
      letters.forEach(function (l) { l.classList.add('in'); });
      fades.forEach(function (f) { f.classList.add('in'); });
    } else {
      letters.forEach(function (l, i) { setTimeout(function () { l.classList.add('in'); }, 700 + i * 55); });
      fades.forEach(function (f, i) { setTimeout(function () { f.classList.add('in'); }, 1300 + i * 120); });

      var head = hero.querySelector('.cd-hero__head');
      var raf = 0;
      window.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var y = Math.min(window.scrollY, window.innerHeight);
          if (head) head.style.transform = 'translateY(' + (y * 0.18) + 'px)';
        });
      }, { passive: true });
    }
  }

  /* ---------------- collection page: facets (filter/sort) auto-submit ---------------- */
  var facetsForm = root.querySelector('[data-cd-facets]');
  if (facetsForm) {
    facetsForm.querySelectorAll('.cd-facets__option input[type="checkbox"], [data-cd-facets-sort]').forEach(function (el) {
      el.addEventListener('change', function () { facetsForm.submit(); });
    });

    // native <details> has no group behaviour, so opening Precio would leave
    // Disponibilidad hanging open behind it — only one panel at a time
    var facetDropdowns = facetsForm.querySelectorAll('.cd-facets__dd');
    facetDropdowns.forEach(function (dd) {
      dd.addEventListener('toggle', function () {
        if (!dd.open) return;
        facetDropdowns.forEach(function (other) {
          if (other !== dd) other.open = false;
        });
      });
    });
  }

  /* ---------------- shop the look: title + tile reveal ---------------- */
  var lookSection = root.querySelector('[data-cd-look]');
  if (lookSection) {
    var lookTitle = lookSection.querySelector('[data-cd-look-title]');
    var lookTiles = lookSection.querySelectorAll('[data-cd-look-tile]');
    if (reduceMotion || !('IntersectionObserver' in window)) {
      if (lookTitle) lookTitle.classList.add('in');
      lookTiles.forEach(function (el) { el.classList.add('in'); });
    } else {
      var lookIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          // the title clip-reveals itself, so the row it sits in is what gets watched
          (entry.target.matches('[data-cd-look-tile]') ? entry.target : lookTitle).classList.add('in');
          lookIo.unobserve(entry.target);
        });
      }, { threshold: 0.2 });
      lookTiles.forEach(function (el) { lookIo.observe(el); });
      // a clip-path'd element reports an intersection ratio of 0 while it is
      // still clipped shut, so it can never trigger its own reveal — watch the
      // unclipped header row instead
      if (lookTitle) lookIo.observe(lookTitle.parentNode);
    }
  }

  /* ---------------- about band: photo carousel ---------------- */
  root.querySelectorAll('[data-cd-band]').forEach(function (band) {
    var slides = band.querySelectorAll('[data-cd-band-slide]');
    var ticks = band.querySelectorAll('[data-cd-band-tick]');
    if (slides.length < 2) return;

    var interval = parseInt(band.dataset.cdBandInterval, 10) || 5000;
    var index = 0;
    var timer = null;

    // pull the next photo down a full interval early — a slide that is still
    // downloading when its turn comes would fade up to bare background, which
    // reads as the carousel stalling
    function warm(i) {
      var img = slides[(i + slides.length) % slides.length].querySelector('img');
      if (img && img.loading === 'lazy' && !img.complete) img.loading = 'eager';
    }

    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      warm(index + 1);
      ticks.forEach(function (t, i) {
        var fill = t.querySelector('.cd-band__tick-fill');
        t.classList.toggle('is-active', i === index);
        if (!fill) return;
        // width is driven inline at both ends: an inline 0 would otherwise outrank
        // the stylesheet's is-active width and the bar would never fill. The reflow
        // commits the reset so the browser animates instead of coalescing the two.
        fill.style.transitionDuration = '0ms';
        fill.style.width = '0%';
        void fill.offsetWidth;
        if (i === index) {
          fill.style.transitionDuration = reduceMotion ? '0ms' : interval + 'ms';
          fill.style.width = '100%';
        }
      });
    }
    function play() { if (!reduceMotion && !timer) timer = setInterval(function () { show(index + 1); }, interval); }
    function pause() { if (timer) { clearInterval(timer); timer = null; } }

    // clicking a tick re-bases the timer on that slide; it keeps running either way.
    // Deliberately no hover pause — the band should never appear to stop just
    // because the pointer happens to be resting over it.
    ticks.forEach(function (t, i) {
      t.addEventListener('click', function () { pause(); show(i); play(); });
    });

    show(0);
    // only run while the band is actually on screen
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { play(); } else { pause(); } });
      }, { threshold: 0.15 }).observe(band);
    } else {
      play();
    }
  });

  /* ---------------- search page: clear button ---------------- */
  var heroSearchForm = root.querySelector('.cd-coll-hero__searchform');
  if (heroSearchForm) {
    var hsInput = heroSearchForm.querySelector('.cd-coll-hero__searchinput');
    var hsClear = heroSearchForm.querySelector('[data-cd-search-clear]');
    if (hsInput && hsClear) {
      var syncSearchClear = function () { hsClear.hidden = hsInput.value.length === 0; };
      syncSearchClear();
      hsInput.addEventListener('input', syncSearchClear);
      hsClear.addEventListener('click', function () {
        hsInput.value = '';
        syncSearchClear();
        hsInput.focus();
      });
    }
  }

  /* ---------------- marcas: brand switcher ----------------
     Each brand's row is already in the DOM, so a tab press is just a
     visibility swap — nothing to fetch, nothing to lay out from scratch.
     The product cells carry data-cd-cell, so the detail-panel binding further
     down picks them up like any other cell. */
  var brandsSection = root.querySelector('[data-cd-brands]');
  if (brandsSection) {
    var brandTabs = brandsSection.querySelectorAll('[data-cd-brand-tab]');
    var brandViews = brandsSection.querySelectorAll('[data-cd-brand-view]');
    var brandAll = brandsSection.querySelector('[data-cd-brands-all]');

    var brandSwapTimer = null;

    /* Paging within one brand: the track holds every page side by side, so
       moving is one transform. `animate` is false when a brand is switched in,
       so the new row starts on page 1 without visibly rewinding. */
    var setBrandPage = function (view, idx, animate) {
      var track = view.querySelector('[data-cd-brand-track]');
      if (!track) return;
      var pages = track.children.length;
      if (idx < 0) idx = 0;
      if (idx > pages - 1) idx = pages - 1;
      view.dataset.page = String(idx);

      if (!animate || reduceMotion) {
        track.style.transition = 'none';
        track.style.transform = 'translateX(' + (-100 * idx) + '%)';
        void track.offsetWidth; // land the jump before transitions are handed back
        track.style.transition = '';
      } else {
        track.style.transform = 'translateX(' + (-100 * idx) + '%)';
      }

      var prev = view.querySelector('[data-cd-brand-prev]');
      var next = view.querySelector('[data-cd-brand-next]');
      if (prev) prev.disabled = idx <= 0;
      if (next) next.disabled = idx >= pages - 1;
    };

    brandViews.forEach(function (view) {
      var prev = view.querySelector('[data-cd-brand-prev]');
      var next = view.querySelector('[data-cd-brand-next]');
      var page = function () { return parseInt(view.dataset.page || '0', 10); };
      if (prev) prev.addEventListener('click', function () { setBrandPage(view, page() - 1, true); });
      if (next) next.addEventListener('click', function () { setBrandPage(view, page() + 1, true); });
      setBrandPage(view, 0, false);
    });

    var showBrand = function (handle, url) {
      var next = null, current = null;
      brandViews.forEach(function (v) {
        if (v.dataset.cdBrandView === handle) next = v;
        if (!v.hidden) current = v;
      });
      if (!next) return;

      // the tab answers immediately, whatever the rows are doing
      brandTabs.forEach(function (t) {
        var on = t.dataset.cdBrandTab === handle;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (brandAll && url) brandAll.href = url; // "Ver todo" follows the open brand
      if (next === current) return;

      var settle = function () {
        brandViews.forEach(function (v) {
          if (v !== next) { v.hidden = true; v.classList.remove('is-fading'); }
        });
        setBrandPage(next, 0, false); // every brand opens on its first six
      };

      if (reduceMotion) { next.hidden = false; settle(); return; }

      // Cross-fade. `hidden` is display:none, so an incoming row cannot
      // transition from it — it has to be made transparent first, shown, then
      // released a beat later. clearTimeout keeps fast tab-mashing from
      // leaving two rows visible at once.
      clearTimeout(brandSwapTimer);
      if (current) current.classList.add('is-fading');
      brandSwapTimer = setTimeout(function () {
        next.classList.add('is-fading');
        next.hidden = false;
        settle();
        brandSwapTimer = setTimeout(function () { next.classList.remove('is-fading'); }, 20);
      }, 220);
    };

    brandTabs.forEach(function (t) {
      t.addEventListener('click', function () { showBrand(t.dataset.cdBrandTab, t.dataset.cdBrandUrl); });
    });
  }

  /* ---------------- shop grid: filter + reveal ---------------- */
  var grid = root.querySelector('[data-cd-grid]');
  if (grid) {
    var filterBtns = root.querySelectorAll('[data-cd-filter]');
    // each category (including TODO) has its own server-rendered magazine
    // grid, built with the same 4-across / big-cell row rule — filtering
    // just swaps which pre-built grid is visible, so the layout never gaps
    var views = {};
    views.TODO = grid;
    root.querySelectorAll('[data-cd-grid-alt]').forEach(function (el) {
      views[el.dataset.cdCatView] = el;
    });
    var countEl = root.querySelector('[data-cd-filter-count]');

    function applyFilter(cat) {
      var active = views[cat] || views.TODO;
      Object.keys(views).forEach(function (key) {
        views[key].hidden = views[key] !== active;
      });

      var cellsIn = active.querySelectorAll('.cd-cell');
      cellsIn.forEach(function (cell, idx) {
        if (!reduceMotion) {
          cell.classList.remove('in');
          setTimeout(function () { cell.classList.add('in'); }, (idx % 3) * 80);
        } else {
          cell.classList.add('in');
        }
      });

      // count real products only — the editorial feature cells are <a> tiles
      // without data-cd-cell, and must not inflate the "N PIEZAS" label
      var productCount = active.querySelectorAll('[data-cd-cell]').length;
      if (countEl) countEl.textContent = String(productCount).padStart(2, '0') + ' ' + (productCount === 1 ? 'PIEZA' : 'PIEZAS');
      filterBtns.forEach(function (b) { b.classList.toggle('is-active', b.dataset.cdFilter === cat); });
    }

    filterBtns.forEach(function (b) {
      b.addEventListener('click', function () { applyFilter(b.dataset.cdFilter); });
    });

    // reveal-on-scroll (initial TODO view only — filtered views reveal immediately on switch)
    var cells = grid.querySelectorAll('.cd-cell');
    if (reduceMotion) {
      cells.forEach(function (c) { c.classList.add('in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });
      cells.forEach(function (c) { io.observe(c); });
    }

    // section heading clip-reveal
    var titleIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('in'); titleIo.disconnect(); }
      });
    }, { threshold: 0.4 });
    var shopTitle = root.querySelector('[data-cd-shop-title]');
    if (shopTitle) titleIo.observe(shopTitle);
  }

  /* ---------------- footer: logo reveal ---------------- */
  var footerLogo = root.querySelector('.cd-footer__logo');
  if (footerLogo) {
    if (reduceMotion) {
      footerLogo.classList.add('in');
    } else {
      var fIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            footerLogo.classList.add('in');
            fIo.disconnect();
          }
        });
      }, { threshold: 0.3 });
      fIo.observe(footerLogo.closest('.cd-footer'));
    }
  }

  /* ---------------- footer: newsletter signup (ajax, native Shopify customer form) ---------------- */
  var newsletterForm = root.querySelector('[data-cd-newsletter]');
  if (newsletterForm) {
    var newsletterNote = newsletterForm.querySelector('[data-cd-newsletter-note]');
    var newsletterSubmit = newsletterForm.querySelector('.cd-newsletter-form__submit');
    newsletterForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var emailInput = newsletterForm.querySelector('input[type="email"]');
      if (!emailInput || !emailInput.checkValidity()) {
        if (emailInput) emailInput.reportValidity();
        return;
      }
      if (newsletterSubmit) newsletterSubmit.disabled = true;
      fetch('/contact', { method: 'POST', body: new FormData(newsletterForm) })
        .then(function (res) {
          if (!newsletterNote) return;
          newsletterNote.hidden = false;
          if (res.ok) {
            newsletterNote.textContent = '¡Gracias! Ya estás suscrito.';
            newsletterNote.classList.remove('is-error');
            newsletterForm.reset();
          } else {
            newsletterNote.textContent = 'Algo salió mal. Intenta de nuevo.';
            newsletterNote.classList.add('is-error');
          }
        })
        .catch(function () {
          if (!newsletterNote) return;
          newsletterNote.hidden = false;
          newsletterNote.textContent = 'Algo salió mal. Intenta de nuevo.';
          newsletterNote.classList.add('is-error');
        })
        .finally(function () {
          if (newsletterSubmit) newsletterSubmit.disabled = false;
        });
    });
  }

  /* ---------------- product detail panel ---------------- */
  /* The row under the detail view. Its products come from the grid cells
     already on the page, so there is no second data source to keep in step and
     no request to wait on — and choosing one just re-opens this same panel on
     it. Same category first, then whatever else is on the page, so the row is
     relevant when it can be and still full when it cannot. */
  function renderRelated(currentCell) {
    var wrap = detailPanel.querySelector('[data-cd-rel]');
    var row = detailPanel.querySelector('[data-cd-rel-row]');
    if (!wrap || !row) return;

    var others = [].slice.call(root.querySelectorAll('[data-cd-cell]')).filter(function (c) {
      return c !== currentCell && c.dataset.cdProduct;
    });
    var cat = currentCell.dataset.category;
    var sameCat = others.filter(function (c) { return c.dataset.category === cat; });
    var restCat = others.filter(function (c) { return c.dataset.category !== cat; });
    var picks = sameCat.concat(restCat).slice(0, 4);

    row.innerHTML = '';
    if (!picks.length) { wrap.hidden = true; return; }

    picks.forEach(function (cell) {
      var d;
      try { d = JSON.parse(cell.dataset.cdProduct); } catch (e) { return; }

      var btn = document.createElement('a');
      if (d.url) btn.href = d.url;
      btn.className = 'cd-rel__cell';
      btn.setAttribute('data-cursor', 'link');

      var media = document.createElement('span');
      media.className = 'cd-rel__media';
      var src = (d.images && d.images[0]) || d.image || '';
      if (src) {
        var img = document.createElement('img');
        // the cell JSON only carries the 1800px gallery source; these render at
        // a quarter width, so ask the CDN for a thumbnail instead
        img.src = src.replace(/([?&]width=)\d+/, '$1600');
        img.alt = d.name || '';
        img.loading = 'lazy';
        media.appendChild(img);
      }

      var info = document.createElement('span');
      info.className = 'cd-rel__info';
      var name = document.createElement('span');
      name.className = 'cd-rel__name';
      name.textContent = d.name || '';
      var price = document.createElement('span');
      price.className = 'cd-rel__price';
      price.textContent = d.priceFormatted || '';
      if (d.compareFormatted) {
        var relOld = document.createElement('s');
        relOld.className = 'cd-price-old';
        relOld.textContent = d.compareFormatted;
        price.appendChild(relOld);
      }
      info.appendChild(name);
      info.appendChild(price);

      btn.appendChild(media);
      btn.appendChild(info);
      btn.addEventListener('click', function (e) {
        if (opensElsewhere(e)) return;
        e.preventDefault();
        openDetail(cell);
      });
      row.appendChild(btn);
    });

    wrap.hidden = false;
  }

  // Keeps the Add to cart / Buy now buttons disabled while no size is selected
  // or the selected one is sold out. Sold-out sizes can still be selected so
  // their price shows (sizes are priced differently); Add to cart reads
  // "Agotado" while one is.
  function soldOutLabel() {
    // lo de Próximamente no está agotado, todavía no llega (ver cd-coming-soon.liquid)
    if (state.product && state.product.proximamente) return 'Próximamente';
    return 'Agotado';
  }

  /* ---------------- stock en Chile para visitantes de afuera ----------------
     La tienda sólo envía a Chile, así que fuera del país Shopify marca todo como
     no disponible y esconde el stock al tema. Para que las rejillas y las tallas
     digan lo mismo que en Chile, se le pregunta a la Storefront API (acceso sin
     token) con @inContext(country: CL). Las insignias llegan ocultas con
     data-cd-cl-check (snippets/cd-sold-out-badge.liquid); el botón de compra
     queda deshabilitado con "Solo envíos dentro de Chile". */
  var clStock = { ready: false, products: {}, variants: {} };

  function sizeAvailable(s) {
    if (!s) return false;
    var key = String(s.variantId || s.id);
    if (window.cdOutsideChile && clStock.ready && key in clStock.variants) return clStock.variants[key];
    return s.available !== false;
  }

  function checkChileStock() {
    if (!window.cdOutsideChile || !window.fetch) return;
    var ids = {};
    root.querySelectorAll('[data-cd-cl-check]').forEach(function (el) { ids[el.dataset.cdClCheck] = true; });
    if (isProduct && state.product && state.product.productId) ids[state.product.productId] = true;
    var all = Object.keys(ids);
    var chunks = [];
    for (var i = 0; i < all.length; i += 50) chunks.push(all.slice(i, i + 50));
    var query = 'query ($ids: [ID!]!) @inContext(country: CL) { nodes(ids: $ids) { ... on Product { id availableForSale variants(first: 100) { nodes { id availableForSale } } } } }';
    Promise.all(chunks.map(function (chunk) {
      return fetch('/api/2025-07/graphql.json', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ query: query, variables: { ids: chunk.map(function (id) { return 'gid://shopify/Product/' + id; }) } })
      }).then(function (r) { return r.json(); }).then(function (json) {
        ((json.data && json.data.nodes) || []).forEach(function (p) {
          if (!p) return;
          clStock.products[p.id.split('/').pop()] = p.availableForSale;
          ((p.variants && p.variants.nodes) || []).forEach(function (v) {
            clStock.variants[v.id.split('/').pop()] = v.availableForSale;
          });
        });
      });
    })).then(function () {
      clStock.ready = true;
      root.querySelectorAll('[data-cd-cl-check]').forEach(function (el) {
        if (clStock.products[el.dataset.cdClCheck] === false) el.hidden = false;
      });
      applyChileStockToSizes();
    }).catch(function () {});
  }

  // Corrige las tallas ya pintadas (ficha, o el panel si se abrió antes de que
  // llegara la respuesta) y elige la primera disponible si no había ninguna.
  function applyChileStockToSizes() {
    if (!detailPanel || !state.product) return;
    var wrap = detailPanel.querySelector('[data-cd-pd-sizes]');
    if (wrap) {
      var firstAvail = null;
      wrap.querySelectorAll('.cd-size').forEach(function (btn) {
        var ok = sizeAvailable({ variantId: btn.dataset.variantId });
        btn.classList.toggle('is-sold-out', !ok);
        btn.title = ok ? '' : soldOutLabel();
        if (ok && !firstAvail) firstAvail = btn;
      });
      if (!state.size && firstAvail) firstAvail.click();
    }
    updatePdAddState();
  }

  function updatePdAddState() {
    if (!detailPanel) return;
    // sold out = the selected size is, or (nothing selected) every size is.
    // La ficha trae `variants`, el panel `sizes`.
    var sizes = (state.product && (state.product.sizes || state.product.variants)) || [];
    var outside = !!window.cdOutsideChile;
    var soldOut = (outside && !clStock.ready)
      ? false
      : state.size
        ? !sizeAvailable(state.size)
        : sizes.length > 0 && !sizes.some(sizeAvailable);
    var disabled = !state.size || soldOut || outside;
    var pdAdd = detailPanel.querySelector('[data-cd-pd-add]');
    var pdBuyNow = detailPanel.querySelector('[data-cd-pd-buynow]');
    [pdAdd, pdBuyNow].forEach(function (btn) {
      if (!btn) return;
      btn.disabled = disabled;
      btn.classList.toggle('is-disabled', disabled);
    });
    // fuera de Chile se ve lo agotado como agotado, pero lo disponible no se puede
    // comprar: la tienda sólo envía a Chile
    if (pdAdd) pdAdd.textContent = soldOut ? soldOutLabel() : outside ? 'Solo envíos dentro de Chile' : 'Agregar al carrito';
  }

  // The cell JSON only carries the 1800px gallery source (see cd-shop-grid-rows.liquid),
  // which is sized for a desktop monitor. Ask the CDN for a width matching the
  // screen instead, so phones on cellular aren't downloading 3-5x the pixels
  // they can even show.
  function galleryImageWidth() {
    var target = (window.innerWidth || 400) * (window.devicePixelRatio || 1);
    var steps = [400, 600, 800, 1000, 1200, 1600, 1800];
    for (var i = 0; i < steps.length; i++) {
      if (target <= steps[i]) return steps[i];
    }
    return steps[steps.length - 1];
  }

  // Sizes can be priced differently (a tracksuit set vs. just the hoodie, some
  // sneaker sizes), so the price shown follows the selected size. Cells rendered
  // before sizes carried a price keep the product-level price.
  function setPdPrice(size) {
    if (!detailPanel || !size || !size.priceFormatted) return;
    var priceEl = detailPanel.querySelector('[data-cd-pd-price]');
    if (priceEl) priceEl.textContent = size.priceFormatted;
    setPdOldPrice(size.compareFormatted);
  }

  // Precio de comparación (el "antes" tachado). Vacío = sin rebaja, se esconde.
  function setPdOldPrice(compare) {
    var oldEl = detailPanel && detailPanel.querySelector('[data-cd-pd-price-old]');
    if (!oldEl) return;
    oldEl.textContent = compare || '';
    oldEl.hidden = !compare;
  }

  /* Product photos: one at a time, stepped with the arrow buttons (or a swipe,
     or the keyboard arrows) instead of scrolling. Works on whatever <img>s are
     inside the gallery, so the overlay (built in openDetail) and the server-
     rendered product page share it. Safe to call again after the images change. */
  function setupGallery(gallery) {
    if (!gallery) return;
    var imgs = [].slice.call(gallery.querySelectorAll('img'));
    gallery.querySelectorAll('.cd-pd__nav, .cd-pd__count').forEach(function (el) { el.remove(); });
    gallery.cdIndex = 0;
    gallery.cdTotal = imgs.length;
    imgs.forEach(function (img, i) { img.classList.toggle('is-active', i === 0); });
    gallery.classList.add('is-slider');
    if (imgs.length < 2) return;

    var count = document.createElement('span');
    count.className = 'cd-pd__count';
    count.setAttribute('aria-live', 'polite');

    function show(i) {
      var n = gallery.cdTotal;
      gallery.cdIndex = (i + n) % n;
      imgs.forEach(function (img, k) {
        var active = k === gallery.cdIndex;
        img.classList.toggle('is-active', active);
        // lazy images outside the viewport never start loading on their own
        if (active && img.loading === 'lazy') img.loading = 'eager';
      });
      count.textContent = (gallery.cdIndex + 1) + ' / ' + n;
    }
    gallery.cdShow = show;

    [['prev', 'Foto anterior', 'M15 5l-7 7 7 7'], ['next', 'Foto siguiente', 'M9 5l7 7-7 7']].forEach(function (d) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cd-pd__nav cd-pd__nav--' + d[0];
      btn.setAttribute('aria-label', d[1]);
      btn.setAttribute('data-cursor', 'link');
      btn.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + d[2] + '"/></svg>';
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        show(gallery.cdIndex + (d[0] === 'next' ? 1 : -1));
      });
      gallery.appendChild(btn);
    });
    gallery.appendChild(count);
    show(0);

    if (!gallery.cdSwipeBound) {
      gallery.cdSwipeBound = true;
      var startX = null, startY = null;
      gallery.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX; startY = e.touches[0].clientY;
      }, { passive: true });
      gallery.addEventListener('touchend', function (e) {
        if (startX === null || !gallery.cdShow || gallery.cdTotal < 2) return;
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        startX = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) gallery.cdShow(gallery.cdIndex + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    if (!detailPanel || !(isProduct || state.detailOpen) || state.bagOpen) return;
    var t = e.target;
    if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
    var g = detailPanel.querySelector('[data-cd-pd-gallery]');
    if (!g || !g.cdShow || g.cdTotal < 2) return;
    g.cdShow(g.cdIndex + (e.key === 'ArrowRight' ? 1 : -1));
  });

  function openDetail(cell) {
    if (!detailPanel) return;
    var data = JSON.parse(cell.dataset.cdProduct);
    state.product = data;
    state.size = null;
    state.qty = 1;

    var gallery = detailPanel.querySelector('[data-cd-pd-gallery]');
    if (gallery) {
      gallery.innerHTML = '';
      var galleryImgs = (data.images && data.images.length ? data.images : [data.image]).filter(Boolean);
      var galleryWidth = galleryImageWidth();
      galleryImgs.forEach(function (src, i) {
        var img = document.createElement('img');
        img.src = src.replace(/([?&]width=)\d+/, '$1' + galleryWidth);
        img.alt = data.name + (i > 0 ? ' — ' + (i + 1) : '');
        img.loading = i === 0 ? 'eager' : 'lazy';
        gallery.appendChild(img);
      });
      setupGallery(gallery);
    }
    detailPanel.querySelector('[data-cd-pd-type]').textContent = data.type;
    detailPanel.querySelector('[data-cd-pd-name]').textContent = data.name;
    detailPanel.querySelector('[data-cd-pd-price]').textContent = data.priceFormatted;
    setPdOldPrice(data.compareFormatted);
    detailPanel.querySelector('[data-cd-pd-desc]').textContent = data.description;

    // The consignment notice is the only label the store puts on a product, and
    // only on the ones tagged `consignacion` — same wording the server renders on
    // /products/* (sections/capsule-product.liquid).
    var pdNotice = detailPanel.querySelector('[data-cd-pd-notice]');
    if (pdNotice) pdNotice.hidden = data.consignacion !== true;

    // "Distribuidor oficial" — Godspeed, Lost Intricacy y Guapi. Quién la lleva lo
    // decide snippets/cd-brand-official.liquid (la consignación la anula allí), así
    // que aquí sólo se enciende el flag que trae la celda.
    var pdOfficial = detailPanel.querySelector('[data-cd-pd-official]');
    if (pdOfficial) pdOfficial.hidden = data.oficial !== true;

    // Products don't all name their first option the same way ("Talla",
    // "Talla del calzado"), so the overlay follows the product like the page does.
    var pdLabel = detailPanel.querySelector('[data-cd-pd-label]');
    if (pdLabel && data.optionLabel) pdLabel.textContent = data.optionLabel;

    var sizesWrap = detailPanel.querySelector('[data-cd-pd-sizes]');
    sizesWrap.innerHTML = '';
    var firstAvailable = null;
    (data.sizes || []).forEach(function (s) {
      var isAvailable = sizeAvailable(s);

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cd-size' + (isAvailable ? '' : ' is-sold-out');
      btn.textContent = s.label;
      btn.dataset.variantId = s.variantId;

      if (isAvailable && !firstAvailable) firstAvailable = s;
      if (!isAvailable) btn.title = soldOutLabel();
      btn.addEventListener('click', function () {
        sizesWrap.querySelectorAll('.cd-size').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        state.size = s;
        setPdPrice(s);
        updatePdAddState();
      });

      sizesWrap.appendChild(btn);
    });

    // Open on the first size that can be bought; sold-out ones are only
    // selected when the visitor taps them to see their price.
    state.size = firstAvailable;
    if (firstAvailable) {
      var firstBtn = sizesWrap.querySelector('.cd-size:not(.is-sold-out)');
      if (firstBtn) firstBtn.classList.add('is-selected');
      setPdPrice(firstAvailable);
    }
    updatePdAddState();

    renderQty(detailPanel.querySelector('[data-cd-pd-qty]'), state.qty, function (q) { state.qty = q; });

    renderRelated(cell);
    detailPanel.scrollTop = 0; // a re-open from the related row must not inherit the old scroll

    detailPanel.classList.add('is-open');
    state.detailOpen = true;
    scheduleOverlayHistory();
    lockScroll();
    setTimeout(function () { detailPanel.classList.add('is-revealed'); }, 240);
  }

  function closeDetail() {
    // on /products/* the detail view IS the page, never an overlay to close
    if (!detailPanel || isProduct) return;
    detailPanel.classList.remove('is-open', 'is-revealed');
    state.detailOpen = false;
    scheduleOverlayHistory();
    if (!state.bagOpen) unlockScroll();
  }

  if (detailPanel && !isProduct) {
    /* The gallery is a mandatory scroll-snap container, and Chrome keeps the
       wheel latched to one of those even once it has hit its end — so the
       gesture never chains out to the panel and the related row below stays
       unreachable from the picture column, which is the way in that matters.
       Hand the wheel over ourselves when the gallery has nothing left to give.
       (The info column needs none of this: no snapping, so it chains on its own.) */
    var pdGallery = detailPanel.querySelector('[data-cd-pd-gallery]');
    if (pdGallery) {
      pdGallery.addEventListener('wheel', function (e) {
        if (!e.deltaY) return;
        var atEnd = pdGallery.scrollTop + pdGallery.clientHeight >= pdGallery.scrollHeight - 1;
        var atStart = pdGallery.scrollTop <= 0;
        if ((e.deltaY > 0 && atEnd) || (e.deltaY < 0 && atStart)) {
          var before = detailPanel.scrollTop;
          detailPanel.scrollTop = before + e.deltaY;
          // only swallow the gesture if we actually moved, so the page keeps
          // behaving normally at the very top of the panel
          if (detailPanel.scrollTop !== before) e.preventDefault();
        }
      }, { passive: false });
    }

    var pdBack = detailPanel.querySelector('[data-cd-pd-back]');
    if (pdBack) pdBack.addEventListener('click', closeDetail);
    var pdAdd = detailPanel.querySelector('[data-cd-pd-add]');
    if (pdAdd) pdAdd.addEventListener('click', function () {
      if (!state.product || !state.size) return;
      addToCart(state.size.variantId, state.qty, function () {
        closeDetail();
        openBag();
      });
    });
    var pdBuyNow = detailPanel.querySelector('[data-cd-pd-buynow]');
    if (pdBuyNow) pdBuyNow.addEventListener('click', function () {
      if (!state.product || !state.size) return;
      pdBuyNow.disabled = true;
      pdBuyNow.textContent = 'Redirigiendo…';
      setTimeout(function () { pdBuyNow.disabled = false; pdBuyNow.textContent = 'Comprar ahora'; }, 6000);
      addToCart(state.size.variantId, state.qty, function () {
        var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        navigatingAway = true;
        window.location.href = rootUrl + 'checkout';
      });
    });
  }

  // cells are links to /products/*: a plain click opens the panel instead, but
  // cmd/ctrl/shift/middle-click and "copy link" still get the real page
  function opensElsewhere(e) {
    return e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || (e.button && e.button !== 0);
  }

  root.querySelectorAll('[data-cd-cell]').forEach(function (cell) {
    cell.addEventListener('click', function (e) {
      if (opensElsewhere(e)) return;
      e.preventDefault();
      openDetail(cell);
    });
  });

  /* ---------------- share ----------------
     location.href is the product's URL both on /products/* and while the
     overlay is open (see overlay <-> browser history above). Native share sheet
     where there is one (phones), else copy and say so on the button. */
  if (detailPanel) {
    var shareBtn = detailPanel.querySelector('[data-cd-pd-share]');
    var shareLabel = shareBtn && shareBtn.querySelector('[data-cd-pd-share-label]');
    var shareTimer = null;
    var shareSay = function (text) {
      if (!shareLabel) return;
      shareLabel.textContent = text;
      clearTimeout(shareTimer);
      shareTimer = setTimeout(function () { shareLabel.textContent = 'Compartir'; }, 2200);
    };
    var shareCopy = function (url) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () { shareSay('Link copiado'); }, function () { window.prompt('Copia el link:', url); });
      } else {
        window.prompt('Copia el link:', url);
      }
    };
    if (shareBtn) shareBtn.addEventListener('click', function () {
      var url = location.origin + location.pathname;
      var nameEl = detailPanel.querySelector('[data-cd-pd-name], .cd-pd__name');
      var title = (state.product && state.product.name) || (nameEl && nameEl.textContent.trim()) || document.title;
      if (navigator.share && window.matchMedia('(hover: none)').matches) {
        navigator.share({ title: title + ' — Capsule District', url: url }).catch(function () {});
      } else {
        shareCopy(url);
      }
    });
  }

  /* ---------------- standalone product page (/products/*) ----------------
     sections/capsule-product.liquid server-renders the same detail markup as a
     page, so there is nothing to fill in — only the size pills, quantity and the
     two CTAs need wiring, against the variant list the section embeds. */
  if (isProduct && detailPanel) {
    var productJsonEl = root.querySelector('[data-cd-product-json]');
    var productData = { variants: [], selected: null };
    try { productData = JSON.parse(productJsonEl.textContent); } catch (e) {}

    state.product = productData;
    state.qty = 1;
    state.size = productData.selected ? { variantId: productData.selected, available: true } : null;

    var pagePrice = detailPanel.querySelector('[data-cd-pd-price]');
    var pageSizes = detailPanel.querySelector('[data-cd-pd-sizes]');
    if (pageSizes) {
      pageSizes.querySelectorAll('.cd-size').forEach(function (btn) {
        btn.addEventListener('click', function () {
          pageSizes.querySelectorAll('.cd-size').forEach(function (b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          state.size = { variantId: btn.dataset.variantId, available: !btn.classList.contains('is-sold-out') };
          if (pagePrice && btn.dataset.price) pagePrice.textContent = btn.dataset.price;
          var pageOld = detailPanel.querySelector('[data-cd-pd-price-old]');
          if (pageOld) {
            pageOld.textContent = btn.dataset.compare || '';
            pageOld.hidden = !btn.dataset.compare;
          }
          // keep ?variant= in the URL so a shared link lands on the same size
          try {
            var u = new URL(location.href);
            u.searchParams.set('variant', btn.dataset.variantId);
            history.replaceState(history.state, '', u.toString());
          } catch (e) {}
          updatePdAddState();
        });
      });
    }
    updatePdAddState();

    renderQty(detailPanel.querySelector('[data-cd-pd-qty]'), state.qty, function (q) { state.qty = q; });

    // Volver: go back to wherever in the store the visitor came from; the link's
    // own href (the product's collection) covers visitors arriving from outside
    var pageBack = detailPanel.querySelector('[data-cd-pd-back]');
    if (pageBack) pageBack.addEventListener('click', function (e) {
      var fromStore = false;
      try { fromStore = document.referrer && new URL(document.referrer).origin === location.origin; } catch (err) {}
      if (fromStore && history.length > 1) { e.preventDefault(); history.back(); }
    });

    var pageAdd = detailPanel.querySelector('[data-cd-pd-add]');
    if (pageAdd) pageAdd.addEventListener('click', function () {
      if (!state.size) return;
      addToCart(state.size.variantId, state.qty, function () { openBag(); });
    });
    var pageBuyNow = detailPanel.querySelector('[data-cd-pd-buynow]');
    if (pageBuyNow) pageBuyNow.addEventListener('click', function () {
      if (!state.size) return;
      pageBuyNow.disabled = true;
      pageBuyNow.textContent = 'Redirigiendo…';
      setTimeout(function () { pageBuyNow.disabled = false; pageBuyNow.textContent = 'Comprar ahora'; }, 6000);
      addToCart(state.size.variantId, state.qty, function () {
        var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        navigatingAway = true;
        window.location.href = rootUrl + 'checkout';
      });
    });

    setupGallery(detailPanel.querySelector('[data-cd-pd-gallery]'));
  }

  // fuera de Chile: insignias y tallas con el stock real de Chile (ver clStock arriba)
  checkChileStock();

  /* ---------------- shared quantity stepper ---------------- */
  function renderQty(container, value, onChange) {
    if (!container) return;
    container.innerHTML = '';
    var inner = document.createElement('div');
    inner.className = 'cd-qty__inner';

    var minus = document.createElement('button');
    minus.type = 'button'; minus.className = 'cd-qty__btn'; minus.textContent = '−';
    minus.setAttribute('aria-label', 'menos');
    minus.disabled = value <= 1;

    var val = document.createElement('span');
    val.className = 'cd-qty__val'; val.textContent = String(value);

    var plus = document.createElement('button');
    plus.type = 'button'; plus.className = 'cd-qty__btn'; plus.textContent = '+';
    plus.setAttribute('aria-label', 'más');

    minus.addEventListener('click', function () { if (value > 1) { value -= 1; onChange(value); renderQty(container, value, onChange); } });
    plus.addEventListener('click', function () { value += 1; onChange(value); renderQty(container, value, onChange); });

    inner.appendChild(minus); inner.appendChild(val); inner.appendChild(plus);
    container.appendChild(inner);
  }

  /* ---------------- bag panel (Shopify Ajax Cart) ---------------- */
  function lockScroll() { document.body.style.overflow = 'hidden'; }
  function unlockScroll() { document.body.style.overflow = ''; }

  function openBag() {
    if (!bagPanel) return;
    bagPanel.classList.add('is-open');
    state.bagOpen = true;
    scheduleOverlayHistory();
    lockScroll();
    // Reveal on a flat timeout, same as openDetail() below — not nested inside
    // the cart fetch. It used to wait on refreshCart's callback, so a slow or
    // failed fetch (e.g. right after the /cart -> home bounce in theme.liquid,
    // see refreshCart's retry) left the row/image permanently at opacity 0:
    // "is-open" was there, "is-revealed" never came, and only the subtotal —
    // which isn't gated behind that class — showed up.
    setTimeout(function () { bagPanel.classList.add('is-revealed'); }, 220);
    refreshCart();
  }
  function closeBag() {
    if (!bagPanel) return;
    bagPanel.classList.remove('is-open', 'is-revealed');
    state.bagOpen = false;
    scheduleOverlayHistory();
    if (!state.detailOpen) unlockScroll();
  }
  if (bagPanel) {
    var bagClose = bagPanel.querySelector('[data-cd-bag-close]');
    if (bagClose) bagClose.addEventListener('click', closeBag);
  }

  /* There's no standalone cart page in this design — the cart is always this
     bag panel. Shopify checkout's "back to cart" link still hard-points at
     /cart, so that page bounces straight here with ?cd_open_bag=1 (see
     theme.liquid) instead of showing the undesigned default cart template. */
  if (isHome) {
    var bagParams = new URLSearchParams(window.location.search);
    if (bagParams.get('cd_open_bag') === '1') {
      bagParams.delete('cd_open_bag');
      var bagQs = bagParams.toString();
      history.replaceState(history.state, '', location.pathname + (bagQs ? '?' + bagQs : '') + location.hash);
      openBag();
    }
  }

  /* ---------------- search overlay ---------------- */
  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.add('is-open');
    searchOverlay.setAttribute('aria-hidden', 'false');
    state.searchOpen = true;
    scheduleOverlayHistory();
    if (searchInput) setTimeout(function () { searchInput.focus(); }, 220);
  }
  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('is-open');
    searchOverlay.setAttribute('aria-hidden', 'true');
    if (searchResults) searchResults.classList.remove('is-open');
    if (searchList) searchList.innerHTML = '';
    if (searchInput) searchInput.value = '';
    state.searchOpen = false;
    scheduleOverlayHistory();
  }
  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function renderSearchResults(products, query) {
    if (!searchList || !searchResults) return;
    searchList.innerHTML = '';
    if (!products.length) {
      searchList.innerHTML = '<div class="cd-search__empty">Sin resultados</div>';
    } else {
      products.forEach(function (p) {
        var img = (p.featured_image && p.featured_image.url) || p.image || '';
        if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=96';
        var a = document.createElement('a');
        a.href = p.url;
        a.className = 'cd-search__item';
        a.setAttribute('data-cursor', 'link');
        a.innerHTML =
          '<img src="' + escapeHtml(img) + '" alt="" loading="lazy">' +
          '<span class="cd-search__item-info">' +
            '<span class="cd-search__item-name">' + escapeHtml(p.title) + '</span>' +
            // suggest.json gives a whole-currency amount ("99990"); formatMoney takes cents
            '<span class="cd-search__item-price">' + escapeHtml(formatMoney(p.price * 100)) +
              (parseFloat(p.compare_at_price_max) > parseFloat(p.price)
                ? '<s class="cd-price-old">' + escapeHtml(formatMoney(p.compare_at_price_max * 100)) + '</s>' : '') +
            '</span>' +
          '</span>';
        searchList.appendChild(a);
      });
    }
    var viewAll = document.createElement('a');
    viewAll.className = 'cd-search__viewall';
    viewAll.href = '/search?q=' + encodeURIComponent(query) + '&type=product';
    viewAll.setAttribute('data-cursor', 'link');
    viewAll.innerHTML = 'Buscar "<span>' + escapeHtml(query) + '</span>"';
    searchList.appendChild(viewAll);
    searchResults.classList.add('is-open');
  }
  var searchTimer = null;
  if (searchInput) {
    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim();
      clearTimeout(searchTimer);
      if (q.length < 2) {
        if (searchResults) searchResults.classList.remove('is-open');
        if (searchList) searchList.innerHTML = '';
        return;
      }
      searchTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=9')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            renderSearchResults(products, q);
          })
          .catch(function () {});
      }, 220);
    });
  }
  var searchOpenBtns = root.querySelectorAll('[data-cd-search-open]');
  searchOpenBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      // The dropdown overlay is sized for a desktop header (a centered 70%-width
      // bar under the nav); on a phone that renders as a small floating box that
      // looks broken. Below the same breakpoint the nav collapses to a burger at,
      // send mobile straight to the full search page instead of opening it.
      if (window.matchMedia('(max-width: 900px)').matches) {
        window.location.href = '/search';
        return;
      }
      openSearch();
    });
  });
  if (searchOverlay) {
    var searchClose = searchOverlay.querySelector('[data-cd-search-close]');
    if (searchClose) searchClose.addEventListener('click', closeSearch);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (state.detailOpen) closeDetail();
    else if (state.bagOpen) closeBag();
    else if (state.searchOpen) closeSearch();
  });

  function setBagCount(n) {
    bagCountEls.forEach(function (el) {
      el.textContent = String(n);
      el.toggleAttribute('hidden', n === 0);
    });
    var bagLink = nav && nav.querySelector('[data-cd-nav-bag]');
    if (bagLink) {
      bagLink.classList.add('is-pop');
      setTimeout(function () { bagLink.classList.remove('is-pop'); }, 320);
    }
  }

  var cartRoot = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url.replace('/cart/add', '/') : '/';

  function addToCart(variantId, quantity, cb) {
    fetch(cartRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity }] }),
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Add failed'); });
        return r.json();
      })
      .then(function () { return refreshCart(cb); })
      .catch(function (err) { console.error('Capsule District: add to cart failed', err); alert('No se pudo agregar: ' + err.message); });
  }

  function changeCartLine(key, quantity, cb) {
    fetch(cartRoot + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshCart(cb); })
      .catch(function (err) { console.error('Capsule District: cart update failed', err); });
  }

  function refreshCart(cb, isRetry) {
    fetch(cartRoot + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderBag(cart); if (cb) cb(); })
      .catch(function (err) {
        // Right after the /cart -> home bounce (see theme.liquid), this first
        // fetch can land on the browser mid-navigation and come back empty.
        // One retry clears it up; without it the panel opened with nothing
        // rendered in it (no image, no name — subtotal/checkout stayed since
        // those come from a different render path) and stayed that way, since
        // nothing ever asked again.
        if (!isRetry) { setTimeout(function () { refreshCart(cb, true); }, 300); return; }
        console.error('Capsule District: cart fetch failed', err);
        if (cb) cb();
      });
  }

  function renderBag(cart) {
    if (!bagPanel) return;
    setBagCount(cart.item_count);

    var body = bagPanel.querySelector('[data-cd-bag-body]');
    if (!body) return;
    body.innerHTML = '';

    var countWrap = bagPanel.querySelector('[data-cd-bag-count-wrap]');

    if (!cart.items.length) {
      if (countWrap) countWrap.style.display = 'none';
      var empty = document.createElement('div');
      empty.className = 'cd-bag__empty';
      empty.innerHTML =
        '<div>' +
          '<div class="cd-bag__empty-line" style="color: var(--cd-white);">¿Ni una sola cosa?</div>' +
          '<div class="cd-bag__empty-line" style="color: var(--cd-ash);">Qué pena.</div>' +
        '</div>' +
        '<span aria-hidden="true" class="cd-bag__empty-symbol">⊙</span>';
      body.appendChild(empty);
      return;
    }

    if (countWrap) { countWrap.style.display = ''; countWrap.textContent = '(' + cart.item_count + ')'; }

    var list = document.createElement('div');
    cart.items.forEach(function (item, i) {
      var row = document.createElement('div');
      row.className = 'cd-bag__row';
      row.style.transitionDelay = (i * 70) + 'ms';

      var imgWrap = document.createElement('div');
      imgWrap.className = 'cd-bag__row-img';
      var imgSrc = (item.featured_image && item.featured_image.url) || item.image || '';
      if (imgSrc) {
        var img = document.createElement('img');
        img.src = imgSrc.startsWith('//') ? 'https:' + imgSrc : imgSrc;
        img.alt = (item.featured_image && item.featured_image.alt) || item.product_title || '';
        img.width = 84; img.height = 84;
        imgWrap.appendChild(img);
      }

      var mid = document.createElement('div');
      var name = document.createElement('div');
      name.className = 'cd-bag__row-name'; name.textContent = item.product_title;
      var meta = document.createElement('div');
      meta.className = 'cd-bag__row-meta';
      meta.textContent = (item.variant_title ? item.variant_title.toUpperCase() : '');
      var qtyWrap = document.createElement('div');
      qtyWrap.className = 'cd-qty';

      mid.appendChild(name); mid.appendChild(meta); mid.appendChild(qtyWrap);

      var price = document.createElement('div');
      price.className = 'cd-bag__row-price';
      if (item.original_line_price !== item.final_line_price) {
        price.classList.add('cd-bag__row-price--sale');
        var oldPrice = document.createElement('s');
        oldPrice.className = 'cd-bag__row-price-old';
        oldPrice.textContent = formatMoney(item.original_line_price);
        var finalPrice = document.createElement('span');
        finalPrice.className = 'cd-bag__row-price-final';
        finalPrice.textContent = formatMoney(item.final_line_price);
        price.appendChild(oldPrice);
        price.appendChild(finalPrice);
      } else {
        price.textContent = formatMoney(item.final_line_price);
      }

      row.appendChild(imgWrap); row.appendChild(mid); row.appendChild(price);
      list.appendChild(row);

      renderQty(qtyWrap, item.quantity, function (q) { changeCartLine(item.key, q); });
      var del = document.createElement('button');
      del.type = 'button'; del.className = 'cd-qty__del'; del.textContent = 'Eliminar';
      del.addEventListener('click', function () { changeCartLine(item.key, 0); });
      qtyWrap.querySelector('.cd-qty__inner').appendChild(makeSpacer());
      qtyWrap.appendChild(del);

      requestAnimationFrame(function () { row.offsetHeight; });
    });
    body.appendChild(list);

    var subtotal = document.createElement('div');
    subtotal.className = 'cd-bag__subtotal';
    subtotal.innerHTML =
      '<span class="cd-bag__subtotal-label">SUBTOTAL</span>' +
      '<span class="cd-bag__subtotal-value">' + formatMoney(cart.items_subtotal_price) + '</span>';
    body.appendChild(subtotal);

    if (cart.total_discount > 0) {
      var savings = document.createElement('div');
      savings.className = 'cd-bag__savings';
      savings.textContent = 'Ahorras ' + formatMoney(cart.total_discount);
      body.appendChild(savings);
    }

    var note = document.createElement('div');
    note.className = 'cd-bag__note';
    note.textContent = 'Impuestos y envío se calculan al pagar.';
    body.appendChild(note);

    var checkoutWrap = document.createElement('div');
    checkoutWrap.className = 'cd-bag__checkout-wrap';
    var checkout = document.createElement('button');
    checkout.type = 'button'; checkout.className = 'cd-checkout'; checkout.setAttribute('data-cursor', 'cta');
    checkout.innerHTML = '<span>Pagar</span><span aria-hidden="true" class="arrow">↗</span>';
    checkout.addEventListener('click', function () {
      navigatingAway = true;
      window.location.href = window.Shopify.routes.root + 'checkout';
    });
    checkoutWrap.appendChild(checkout);
    body.appendChild(checkoutWrap);
  }

  function makeSpacer() {
    var s = document.createElement('span');
    s.style.display = 'inline-block';
    s.style.width = '6px';
    return s;
  }

  // NOTE: takes CENTS (what the Ajax Cart API returns). Callers holding a
  // whole-currency amount — /search/suggest.json does — must multiply by 100.
  function formatMoney(cents) {
    var currency = window.shopCurrency || 'CLP';
    try {
      return new Intl.NumberFormat('es-CL', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return '$' + Math.round(cents / 100);
    }
  }

  // initial bag count on load
  refreshCart();
})();
